import { service } from '../../../../helpers/http'

//Retorna a lista com as categorias de grupos
export const ActionGetCampuses = ({ dispatch }, payload) => {

    return service({
        module: 'domainCampus',
        action: 'getCampuses',
        payload: payload
    })
    
}

//Cadastra uma nova categoria de grupo
export const ActionPostCampuses = ({ dispatch }, payload) => {

    return service({
        module: 'domainCampus',
        action: 'postCampuses',
        payload: payload
    })
    
}

//Atualiza uma categoria de grupo
export const ActionPutCampuses = ({ dispatch }, payload) => {

    return service({
        module: 'domainCampus',
        action: 'putCampuses',
        payload: payload
    })
    
}

//Deleta uma categoria de grupo
export const ActionDeleteCampuses = ({ dispatch }, payload) => {

    return service({
        module: 'domainCampus',
        action: 'deleteCampuses',
        payload: payload
    })

}

export const ActionGetCampusesGerenciaisWithOferta = ({ dispatch }, payload) => {

    return service({
        module: 'domainCampus',
        action: 'getCampusesGerenciaisWithOferta',
        payload: payload
    })

}

export const ActionGetCampusesGerenciais = ({ dispatch }, payload) => {

    return service({
        module: 'domainCampus',
        action: 'getCampusesGerenciais',
        payload: payload
    })

}